<div>
  <a [matMenuTriggerFor]="menu">{{selectedLanguage.name | slice:0:3}}</a>
  <div>
    <mat-menu #menu="matMenu" backdropClass="kkm-mat-menu">
      <button *ngFor="let l of languages; trackByField:'value'" (click)="select(l)" mat-menu-item>{{l.name}}</button>
    </mat-menu>
  </div>
</div>
